import { Box, CircularProgress } from "@mui/material";
import React, { Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";

import "./CSS/Layout.css";
import Frame from "./Components/Frame";
import { GlobalWrapper, publicSites } from "./utils/GlobalContext";

import DrXuPage from "./Pages/DrXu";
import EquipmentPage from "./Pages/Equipment";
import LandingPage from "./Pages/Landing";
import PageNotFound from "./Pages/PageNotFound";
import PeoplePage from "./Pages/People";
import PublicationsPage from "./Pages/Publications";
import ResearchAreaPage from "./Pages/ResearchArea";
import ResourcesPage from "./Pages/Resources";

function App() {
  return (
    <BrowserRouter>
      <Suspense
        fallback={
          <Box className="display-center">
            <CircularProgress sx={{ margin: "auto" }} />
          </Box>
        }
      >
        <GlobalWrapper>
          <Routes>
            <Route path={publicSites.HOME.path} element={<LandingPage />} />
            <Route path={publicSites.RESEARCH_AREA.path} element={<Frame
              content={<ResearchAreaPage />}
              currentPath={publicSites.RESEARCH_AREA.path}
            />} />
            <Route path={publicSites.DR_XU.path} element={<Frame
              content={<DrXuPage />}
              currentPath={publicSites.DR_XU.path}
            />} />
            <Route path={publicSites.PEOPLE.path} element={<Frame
              content={<PeoplePage />}
              currentPath={publicSites.PEOPLE.path}
            />} />
            <Route path={publicSites.PUBLICATIONS.path} element={<Frame
              content={<PublicationsPage />}
              currentPath={publicSites.PUBLICATIONS.path}
            />} />
            <Route path={publicSites.EQUIPMENT.path} element={<Frame
              content={<EquipmentPage />}
              currentPath={publicSites.EQUIPMENT.path}
            />} />
            <Route path={publicSites.RESOURCES.path} element={<Frame
              content={<ResourcesPage />}
              currentPath={publicSites.RESOURCES.path}
            />} />
            <Route path="*" element={<Frame
              content={<PageNotFound />}
              currentPath="*"
            />} />
            <Route path="/images/public/*" element={<Frame
              content={<PageNotFound />}
              currentPath="*"
            />} />
          </Routes>
        </GlobalWrapper>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
